import { HttpErrorResponse } from '@angular/common/http';

export const FORBIDDEN_TOAST_COOLDOWN_MS = 3000;

let lastForbiddenToastAt = 0;

export function resetForbiddenToastCooldown(): void {
  lastForbiddenToastAt = 0;
}

export function forbiddenApiMessage(
  error: HttpErrorResponse,
  fallback = 'No tens permisos per realitzar aquesta acció.',
): string {
  const message = error.error?.message;

  if (typeof message === 'string' && message.length > 0) {
    return message;
  }

  return fallback;
}

export function shouldShowForbiddenToast(url: string, now = Date.now()): boolean {
  if (url.includes('/auth/me')) {
    return false;
  }

  if (
    lastForbiddenToastAt > 0 &&
    now - lastForbiddenToastAt < FORBIDDEN_TOAST_COOLDOWN_MS
  ) {
    return false;
  }

  lastForbiddenToastAt = now;
  return true;
}
